import { request } from "@/utilities/libs/request.ts";
import {
  IUpdateResult,
  IRequestArgs,
  IResponseData,
  ListResponseData,
} from "@/utilities/types/requests.ts";
import { ERequestMethods } from "../enums/RequestMethod";
import { E_UserFlag } from "../enums/UserFlag";
import {
  EUserFlagType,
  ICreateUserFlagDto,
  IGetMeUserFlagDto,
  IUserFlag,
} from "../types/UserFlag";

function getUserFlags({ queryParams }: IRequestArgs) {
  const query = {
    filter: queryParams?.query?.filter,
    sort: queryParams?.query?.sort,
    ...queryParams?.query?.search,
    ...queryParams?.pagination,
  };
  return request<ListResponseData<IUserFlag>>({
    method: ERequestMethods.GET,
    url: E_UserFlag.MAIN,
    params: query,
  });
}

function getMe(data: IGetMeUserFlagDto) {
  return request<IResponseData<IUserFlag[]>>({
    method: ERequestMethods.GET,
    url: E_UserFlag.ME,
    data,
  });
}

function deleteUserFlagById(id: string) {
  return request<IResponseData<IUserFlag>>({
    method: ERequestMethods.DELETE,
    url: E_UserFlag.BY_ID().replace(":id", id),
  });
}

function deleteUserFlagByType(type: EUserFlagType) {
  return request<IResponseData<IUpdateResult>>({
    method: ERequestMethods.DELETE,
    url: E_UserFlag.TYPE_BY_ID().replace(":id", type),
  });
}

function createUserFlag(data: ICreateUserFlagDto) {
  return request<IResponseData<IUserFlag>>({
    method: ERequestMethods.POST,
    url: E_UserFlag.MAIN,
    data,
  });
}

const UserFlagRepository = Object.freeze({
  getUserFlags,
  getMe,
  deleteUserFlagById,
  createUserFlag,
  deleteUserFlagByType,
});

export default UserFlagRepository;
